// import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import L from 'leaflet';
import vuetify from './plugins/vuetify'

Vue.use(L);
Vue.config.productionTip = false

new Vue({
  L,
  vuetify,
  render: h => h(App)
}).$mount('#app')
